(function () {
  function initReveal() {
    var els = document.querySelectorAll('.safra-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initStickyAtc() {
    var atc = document.querySelector('[data-safra-sticky-atc]');
    if (!atc) return;
    function update() {
      var y = window.scrollY;
      var footerEl = document.querySelector('.footer') || document.querySelector('footer');
      var footerTop = footerEl ? footerEl.getBoundingClientRect().top + window.scrollY : Infinity;
      var visible = y > 700 && (y + window.innerHeight) < (footerTop + 100);
      atc.classList.toggle('visible', visible);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initStickyAtc();
    });
  } else {
    initReveal();
    initStickyAtc();
  }
})();
